import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import ModalWrapper from "../../../../../../Components/CustomModal/ModalWrapper";
import { Dropdown } from "primereact/dropdown";
import { getViewIssItems } from "../../../../../../Store/prosafe/proTransaction/ProIssue/getViewIssItems";
import axios from "axios";
import { V_URL } from "../../../../../../BaseUrl";
import { getProStock } from "../../../../../../Store/prosafe/proStock/getProStock";

const ManualIssueModel = ({
  modal,
  itemsArr,
  editingIndex,
  setEditingIndex,
  onSubmit,
  data,
  editItemId,
  setEditItemId,
}) => {
  const [filter, setFilter] = useState({
    date: {
      start: null,
      end: null,
    },
  });

  const [errors, setErrors] = useState({});
  const [totalQty, setTotalQty] = useState(0);
  const dispatch = useDispatch();

  const [plateData, setPlateData] = useState([]);

  const itemData = useSelector((state) => state.getItem?.user?.data) || [];
  const issueStock = useSelector((state) => state.getProStock?.user?.data);
  const stockItems = issueStock?.store_items || [];

  const fetchPlateData = async () => {
    try {
      const res = await axios.get(`${V_URL}/prosafe/get-available-plate-list`);
      setPlateData(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchPlateData();
  }, []);

  const initialFormState = {
    item_id: "",
    item_no: "",
    item_length: "",
    item_width: "",
    item_weight: "",
    item_radius: "",
    item_thickness: "",
    unit: "",
    category: "",
    assembly_weight: "",
    assembly_surface_area: "",
    // rate: '',
    // amount: '',
    // gst: '',
    // gst_amount: '',
    // total_amount: '',
    heat_no: "",
    plat_no: "",
    tc_no: "",
    remarks: "",
    quantity: "",
    req_qty: "",
    isAuto: false,
    from_id: null,
    detail_id: null,
  };

  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    if (editingIndex !== null && itemsArr[editingIndex]) {
      setFormData(itemsArr[editingIndex]);
    } else {
      setFormData(initialFormState);
    }
  }, [editingIndex, itemsArr]);

  useEffect(() => {
    if (formData.item_id) {
      const selectedItem = itemData.find(
        (item) => item._id === formData.item_id
      );
      if (selectedItem) {
        setFormData((prev) => ({
          ...prev,
          item_thickness: editingIndex === null ? selectedItem?.thickness : prev.item_thickness,
          unit: selectedItem?.unit?.name || "",
          category: selectedItem?.category?.name || "",
          gst:
            editingIndex === null
              ? selectedItem?.gst_percentage || ""
              : prev.gst,
        }));
      }
    }
  }, [formData.item_id, itemData]);

  useEffect(() => {
    if (formData.item_id && stockItems.length > 0) {
      const stockItem = stockItems.find((s) => s.item_id === formData.item_id);
      setTotalQty(stockItem?.balance || 0);
    } else {
      setTotalQty(0);
    }
  }, [formData.item_id, stockItems]);

  const fetchData = () => {
    const bodyFormData = new URLSearchParams();
    bodyFormData.append("filter", JSON.stringify(filter));
    bodyFormData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    dispatch(getProStock({ formData: bodyFormData }));
    setDisable(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(() => {
  //     const qty = parseFloat(formData.quantity) || 0;
  //     const rate = parseFloat(formData.rate) || 0;
  //     const gst = parseFloat(formData.gst) || 0;

  //     const amount = qty * rate;
  //     const gst_amount = (amount * gst) / 100;
  //     const total_amount = amount + gst_amount;

  //     setFormData((prev) => ({
  //         ...prev,
  //         amount: amount.toFixed(2),
  //         gst_amount: gst_amount.toFixed(2),
  //         total_amount: total_amount.toFixed(2),
  //     }));
  // }, [formData.quantity, formData.rate, formData.gst]);

  useEffect(() => {
    if (!modal.isShown) {
      setFormData(initialFormState);
      setEditingIndex(null);
      setEditItemId(null);
      setErrors({});
    }
  }, [modal.isShown]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    setErrors((prev) => {
      const newErrors = { ...prev };

      // if (name === "quantity") {
      //   const qty = Number(value) || 0;

      //   if (qty > totalQty) {
      //     newErrors.quantity = `Issue quantity cannot be more than ${totalQty}`;
      //   } else if (qty <= 0) {
      //     newErrors.quantity = "Valid quantity is required";
      //   } else {
      //     delete newErrors.quantity;
      //   }
      // } else if (newErrors[name]) {
      //   delete newErrors[name];
      // }

      if (newErrors[name]) {
        delete newErrors[name];
      }

      return newErrors;
    });
  };

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.item_id) newErrors.item_id = "Item is required";

    const qty = Number(formData.quantity) || 0;

    // if (qty <= 0) {
    //   newErrors.quantity = "Valid quantity is required";
    // } else if (qty > totalQty) {
    //   newErrors.quantity = `Issue quantity cannot be more than ${totalQty}`;
    // }

    if (!formData.quantity || parseFloat(formData.quantity) <= 0) {
      newErrors.quantity = "Valid quantity is required";
    }

    // if (!formData.rate || parseFloat(formData.rate) <= 0)
    //     newErrors.rate = 'Valid rate is required';
    if (!formData.heat_no) newErrors.heat_no = "Heat No. is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormAction = async (e, isAddMore = false) => {
    e.preventDefault();
    if (!validateForm()) return;
    setDisable(true);
    try {
      if (editItemId) {
        const payload = {
          id: data._id,
          item_detail_id: editItemId,
          items_details: {
            item_length: formData.item_length,
            item_width: formData.item_width,
            item_weight: formData.item_weight,
            item_radius: formData.item_radius,
            item_thickness: formData.item_thickness,
            assembly_weight: formData.assembly_weight,
            assembly_surface_area: formData.assembly_surface_area,
            quantity: formData.quantity,
            req_qty: formData.req_qty,
            // rate: formData.rate,
            // amount: formData.amount,
            // gst: formData.gst,
            // gst_amount: formData.gst_amount,
            // total_amount: formData.total_amount,
            heat_no: formData.heat_no,
            plat_no: formData.plat_no,
            tc_no: formData.tc_no,
            remarks: formData.remarks,
          },
        };
        const resp = await axios.put(
          `${V_URL}/prosafe/pro-update-iss-item`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("PAY_USER_TOKEN")}`,
            },
          }
        );
        if (resp.data.success) {
          toast.success(resp.data.message);
          dispatch(getViewIssItems({ formData: { id: data._id } }));
          if (isAddMore) {
            setFormData(initialFormState);
            setEditingIndex(null);
            setEditItemId(null);
            setErrors({});
          } else {
            modal.hide();
            setEditingIndex(null);
            setEditItemId(null);
          }
        }
      } else if (data?._id) {
        const payload = {
          id: data._id,
          items_details: JSON.stringify([formData]),
        };
        const resp = await axios.post(
          `${V_URL}/prosafe/pro-add-iss-item`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("PAY_USER_TOKEN")}`,
            },
          }
        );
        if (resp.data.success) {
          toast.success(resp.data.message);
          dispatch(getViewIssItems({ formData: { id: data._id } }));
          if (isAddMore) {
            setFormData(initialFormState);
            setEditingIndex(null);
            setEditItemId(null);
            setErrors({});
          } else {
            modal.hide();
          }
        } else {
          toast.error(resp.data.message);
        }
      } else {
        onSubmit(formData);
        if (isAddMore) {
          setFormData(initialFormState);
          setEditingIndex(null);
          setEditItemId(null);
          setErrors({});
        } else {
          modal.hide();
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setDisable(false);
    }
  };

  const isDisabled = editItemId || formData.isAuto;

  const filteredPlates = plateData?.filter(
    (p) => p.item_id === formData.item_id
  );

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      plat_no: "",
    }));
  }, [formData.item_id]);

  return (
    <ModalWrapper
      title="Manual Items Details"
      isShown={modal.isShown}
      hide={modal.hide}
      footer={false}
      customSize={"modal-90w"}
    >
      <form>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-12">
            <div className="input-block local-forms">
              <label>
                Item Name <span className="login-danger">*</span>
              </label>
              <Dropdown
                placeholder="Select Item"
                filter
                value={formData.item_id}
                options={itemData.map((e) => ({
                  label: e?.name,
                  value: e?._id,
                }))}
                onChange={(e) => handleDropdownChange("item_id", e.value)}
                filterBy="label"
                enforceFocus={false}
                appendTo="self"
                className={`w-100 ${errors.item_id ? "p-invalid" : ""}`}
                disabled={isDisabled}
              />
              {errors.item_id && (
                <small className="p-error">{errors.item_id}</small>
              )}
            </div>
          </div>
          {formData.item_id && (
            <>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="input-block local-forms">
                  <label>Unit</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.unit || "-"}
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-12">
                <div className="input-block local-forms">
                  <label>Category</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.category || "-"}
                    disabled
                  />
                </div>
              </div>
            </>
          )}

          {/* {formData.item_id && !editItemId && (
            <div className="col-lg-4 col-md-6 col-12">
              <div className="input-block local-forms">
                <label>Plate No.</label>

                <Dropdown
                  value={formData.plat_no}
                  options={filteredPlates.map((p) => ({
                    label: p.plat_no,
                    value: p.plat_no, 
                  }))}
                  onChange={(e) => handleDropdownChange("plat_no", e.value)}
                  placeholder="Select Plate No"
                  filter
                  showClear={!!formData.plat_no} 
                  className={`w-100`}
                  appendTo="self"
                />

                {errors.plat_no && (
                  <small className="p-error">{errors.plat_no}</small>
                )}
              </div>
            </div>
          )} */}


          <div className="col-lg-4 col-md-6 col-12">
            <div className="input-block local-forms">
              <label>Item No</label>
              <input
                type="text"
                className="form-control"
                name="item_no"
                value={formData.item_no}
                onChange={handleChange}
                // disabled={isDisabled}
              />
            </div>
          </div>

          {/* Total Qty (Stock Balance) */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="input-block local-forms">
              <label>Stock Qty</label>
              <input
                type="number"
                className="form-control"
                value={totalQty}
                disabled
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-12">
            <div className="input-block local-forms">
              <label>Requested Qty</label>
              <input
                type="text"
                className="form-control"
                name="req_qty"
                value={formData.req_qty}
                onChange={handleChange}
                // disabled={isDisabled}
              />
            </div>
          </div>

          {[
            // { name: 'item_no', label: 'Item No', type: 'text', disabled: isDisabled },
            {
              name: "quantity",
              label: "Issue Qty",
              required: true,
              type: "number",
              disabled: editItemId,
            },
            { name: "item_length", label: "Length", type: "number" },
            { name: "item_width", label: "Width", type: "number" },
            { name: "item_weight", label: "Weight", type: "number" },
            { name: "item_radius", label: "Radius", type: "number" },
            { name: "item_thickness", label: "Thickness", type: "text" },
            {
              name: "assembly_weight",
              label: "Assembly Weight",
              type: "number",
            },
            {
              name: "assembly_surface_area",
              label: "Surface Area",
              type: "number",
            },
            // { name: 'rate', label: 'Rate(₹)', required: true, type: 'number' },
            // { name: 'amount', label: 'Amount(₹)', type: 'number', disabled: true },
            // { name: 'gst', label: 'GST(%)', type: 'number' },
            // { name: 'gst_amount', label: 'GST Amount(₹)', type: 'number', disabled: true },
            // { name: 'total_amount', label: 'Total Amount(₹)', type: 'number', disabled: true },
            {
              name: "heat_no",
              label: "Heat No.",
              required: true,
              type: "text",
            },
            { name: "plat_no", label: "Plat No.", type: "text" },
            { name: "tc_no", label: "TC No.", type: "text" },
            { name: "remarks", label: "Remarks", type: "text" },
          ].map(({ name, label, required, type, disabled }) => (
            <div key={name} className="col-lg-4 col-md-6 col-12">
              <div className="input-block local-forms">
                <label>
                  {label} {required && <span className="login-danger">*</span>}
                </label>
                <input
                  type={type || "text"}
                  className={`form-control ${errors[name] ? "is-invalid" : ""}`}
                  name={name}
                  value={formData[name]}
                  onChange={handleChange}
                  disabled={disabled || false}
                />
                {errors[name] && (
                  <div className="invalid-feedback">{errors[name]}</div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="col-12 text-end">
          <div className="text-end">
            <button
              type="button"
              className="btn btn-primary"
              disabled={disable}
              onClick={(e) => handleFormAction(e, false)}
            >
              {editingIndex !== null ? "Update" : "Submit"}
            </button>
            {editingIndex === null && (
              <button
                type="button"
                className="btn btn-outline-primary m-2"
                onClick={(e) => handleFormAction(e, true)}
              >
                Add More
              </button>
            )}
          </div>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default ManualIssueModel;
